var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('TopSection',{attrs:{"heading":"Edit Company","user":"J K"}}),_vm._v("\n\tedit company here\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }